import React from 'react';
import styles from './styles.module.scss';

import FormInputText_v2 from 'components/FormComponents/FormInputText/FormInputText_v2';

import { FormProvider, useForm } from 'react-hook-form';

import EditableContent from '../EditableContent';

export default function NotesCellContent({ row, onEdit, isEditable }) {
  const { notes } = row;

  const methods = useForm({
    defaultValues: {
      notes
    }
  });
  const { getValues, setValue } = methods;

  const setDefaultValue = () => setValue('notes', notes);

  const handleAcceptClick = () => {
    onEdit({ ...row, notes: getValues('notes') });
  };

  return (
    <EditableContent
      onAccept={handleAcceptClick}
      isEditable={isEditable}
      setDefaultValue={setDefaultValue}
      hoverPencil
      renderDisplayedComponent={() => <>{notes || '\u2000'}</>}
      renderEditor={() => (
        <FormProvider {...methods}>
          <FormInputText_v2 name="notes" options={{ max: 1000 }} classes={styles.notes__field} />
        </FormProvider>
      )}
    />
  );
}
